import paczkomatyHtml from './paczkomaty.component.html';
import './paczkomaty.component.scss';

class PaczkomatyController {
    constructor($scope, PaczkomatyService, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.service = PaczkomatyService;
        this.CartService = CartService;

        this.selectedMachine = null;
        this.localLoading = true;

        this.cities = [];
        this.citiesQuery = '';
        this.machines = [];
    }

    get customOptions() {
        const options = {};

        options.selected = this.selectedMachine;

        return options;
    }

    $onInit() {
        this.service.loadCities(this.payment.pay_on_delivery).then(
            (cities) => {
                this.cities = cities;
                
                this.service.getStatus().then(
                    (data) => {
                        if (data.machine && data.machine.city && data.machine.name) {
                            this.citiesQuery = data.machine.city;
                            this.service.getMachines(data.machine.city, this.payment).then(
                                (machines) => {
                                    this.machines = machines;

                                    const matches = this.machines.filter(machine => machine.machine == data.machine.name);

                                    if (matches.length > 0) {
                                        matches[0].preselected = true;
                                        this.selectedMachine = matches[0];

                                        this.CartService.shipmentOptions.paczkomaty = this.customOptions;
                                    }

                                    this.localLoading = false;
                                },
                                () => {
                                    this.localLoading = false;
                                }
                            );
                        } else {
                            this.localLoading = false;
                        }
                    },
                    () => {
                        this.localLoading = false;
                    }
                );
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    getMachines(city) {
        this.localLoading = true;
        this.machines = [];
        this.selectedMachine = null;

        this.saveCustomOptions();
        this.service.getMachines(city.value, this.payment).then(
            (machines) => {
                this.machines = machines;
                this.localLoading = false;
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    setMachine(machine) {
        this.localLoading = true;
        this.selectedMachine = machine;

        this.service.setMachine(machine.machine).then(
            (machine) => {
                this.saveCustomOptions();
                this.localLoading = false;
            },
            () => {
                this.selectedMachine = null;
                this.localLoading = false;
            }
        );
    }

    saveCustomOptions() {
        this.save({
            shipment: this.shipment,
            options: this.customOptions
        });
    }

    clear() {
        this.citiesQuery = '';
        this.machines = [];
        this.selectedMachine = null;
    }
}

let paczkomatyComponent = {
    bindings: {
        loading: '<',
        shipment: '<',
        payment: '<',
        selected: '<',
        save: '&'
    },
    template: paczkomatyHtml,
    controller: PaczkomatyController
}

export default paczkomatyComponent;